

















































































































































import {
  defineComponent,
  ref,
  SetupContext,
  useStore,
} from '@nuxtjs/composition-api';
import useLoadingText from '@/compositions/useLoadingText';

export default defineComponent({
  props: {
    isThreeColumn: {
      type: Boolean,
      default: false,
    },
    isHidePc: {
      type: Boolean,
      default: false,
    },
    isHideMobile: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, _context: SetupContext) {
    const isLoading = ref(true);
    const store = useStore();

    const { loadingTextList } = useLoadingText();

    // @ts-ignore
    const iconRandNum = store.state.loading.iconRandNum;
    // @ts-ignore
    const textRandNum = store.state.loading.textRandNum;

    return { isLoading, iconRandNum, textRandNum, loadingTextList };
  },
});
